export const numberDelimiterMapping = {
  comma: ',',
  period: '.',
  space: ' ',
  none: ''
} as const;

type DelimiterType = keyof typeof numberDelimiterMapping;

export function formatDecimalDelimiter(
  decimalDelimiter: DelimiterType,
  thousandDelimiter: DelimiterType
): string {
  const hasSameDelimiter =
    (decimalDelimiter === thousandDelimiter && decimalDelimiter !== 'none') ||
    (decimalDelimiter === thousandDelimiter && decimalDelimiter !== 'space');

  if (decimalDelimiter === 'none') return '';

  if (hasSameDelimiter) {
    return decimalDelimiter === 'comma' ? '.' : ',';
  }

  return numberDelimiterMapping[decimalDelimiter];
}

export function getNumberPrecision(
  precision: string | number | undefined,
  decimalDelimiter: DelimiterType
): number {
  if (!precision || decimalDelimiter === 'none') {
    return 0;
  }

  if (typeof precision === 'string') {
    const parsedPrecision = parseInt(precision, 10);
    return Number.isNaN(parsedPrecision) ? 0 : parsedPrecision;
  }

  return precision;
}
